import { PackingType } from "../../../../app/models/PackingType";
import ButtonTableAction from "../../../../components/buttons/ButtonTableAction";
import DefaultDataTable from "../../../../components/default/DefaultDataTable";

interface Props {
    packingTypes: PackingType[];
    totalRows: number;
    loading?: boolean;
    edit?: (id: number) => void;
    destroy?: (id: number) => void;
    show?: (id: number) => void;
    filter: any;
    setFilter: (filter: any) => void;
}

const PackingTypeDataTable = ({
    packingTypes,
    totalRows,
    loading = false,
    edit,
    destroy,
    show,
    filter,
    setFilter
}: Props) => {
    const columns = [
        {
            name: 'Id',
            selector: (row: PackingType) => row.id,
            sortable: true
        },
        {
            name: 'Nombre',
            selector: (row: PackingType) => row.name,
            sortable: true
        },
        {
            name: 'Categoria',
            selector: (row: PackingType) => row.category,
            sortable: true
        },
        {
            name: 'Actions',
            cell: (row: PackingType) => (
                <>
                    {show && (
                        <ButtonTableAction
                            callbackFunction={() => show(row.id!)}
                            classIcon="mdi mdi-eye"
                            title="View"
                        />
                    )}
                    {edit && (
                        <ButtonTableAction
                            callbackFunction={() => edit(row.id ?? -1)}
                            classIcon={'mdi mdi-pencil'}
                            colorIcon={'text-warning'}
                            errorMessage={'No se puede editar este registro.'}
                            title={'Editar'}
                        />
                    )}
                    {destroy && (
                        <ButtonTableAction
                            callbackFunction={() => destroy(row.id ?? -1)}
                            classIcon={'mdi mdi-delete'}
                            colorIcon={'text-danger'}
                            errorMessage={'No se puede eliminar este registro.'}
                            title={'Eliminar'}
                        />
                    )}
                </>
            )
        }
    ];

    return (
        <DefaultDataTable
            columns={columns}
            data={packingTypes}
            progressPending={loading}
            paginationTotalRows={totalRows}
            filter={filter}
            setFilter={setFilter}
        />
    );
};

export default PackingTypeDataTable;
